import '@ungap/with-resolvers'; // Safari <17.3 polyfill
import * as pdfjs from 'pdfjs-dist';

// "/legacy" should support Safari <17.3, but didn't seem to work.
pdfjs.GlobalWorkerOptions.workerSrc = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@4.8.69/legacy/build/pdf.worker.min.mjs';

export function convertPdfToImage(file: File): Promise<File> {
  return new Promise(resolve => {
    const fileReader = new FileReader();
    fileReader.onload = async () => {
      const pdf = await pdfjs.getDocument(fileReader.result!).promise;
      let overallHeight = 0;
      const renderTasks = [];
      const canvases = [];

      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const page = await pdf.getPage(pageNum);
        const viewport = page.getViewport({ scale: 1 });
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d')!;
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        overallHeight += viewport.height;
        canvases.push(canvas);
  
        const renderContext = {
          canvasContext: context, viewport
        };
        const renderTask = page.render(renderContext).promise;
        renderTasks.push(renderTask);

        if (pageNum < pdf.numPages) continue;
        await Promise.all(renderTasks);
        const finalCanvas = document.createElement('canvas');
        const finalContext = finalCanvas.getContext('2d')!;
        finalCanvas.width = viewport.width;
        finalCanvas.height = overallHeight;

        let yOffset = 0;
        canvases.forEach(canvas => {
          finalContext.drawImage(canvas, 0, yOffset);
          yOffset += canvas.height;
        });
        const blob = await new Promise<Blob | null>(res => finalCanvas.toBlob(res, 'image/jpeg'));
        resolve(new File([blob!], file.name, { type: 'image/jpeg' }));
      }
    };
    fileReader.readAsDataURL(file);
  });
}